(() => {
  if (customElements.get('kivo-home-depth-modes')) {
    return;
  }

  class KivoHomeDepthModes extends HTMLElement {
    connectedCallback() {
      this.stage = this.querySelector('[data-kivo-home-depth-stage]');
      this.tabs = Array.from(this.querySelectorAll('[data-kivo-home-depth-tab]'));
      this.items = Array.from(this.querySelectorAll('[data-kivo-home-depth-item]'));

      if (!this.stage || this.tabs.length === 0 || this.items.length === 0) {
        return;
      }

      this.handleTabClick = this.handleTabClick.bind(this);
      this.handleTabKeydown = this.handleTabKeydown.bind(this);

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', this.handleTabClick);
        tab.addEventListener('keydown', this.handleTabKeydown);
      });

      const selectedTab = this.tabs.find((tab) => tab.getAttribute('aria-selected') === 'true') || this.tabs[0];
      this.setActiveItem(selectedTab.dataset.kivoHomeDepthTab, false);
    }

    disconnectedCallback() {
      if (!this.tabs) {
        return;
      }

      this.tabs.forEach((tab) => {
        tab.removeEventListener('click', this.handleTabClick);
        tab.removeEventListener('keydown', this.handleTabKeydown);
      });
    }

    handleTabClick(event) {
      const mode = event.currentTarget.dataset.kivoHomeDepthTab;
      this.setActiveItem(mode, false);
    }

    handleTabKeydown(event) {
      const handledKeys = ['ArrowLeft', 'ArrowRight', 'Home', 'End'];

      if (!handledKeys.includes(event.key)) {
        return;
      }

      event.preventDefault();

      const currentIndex = this.tabs.indexOf(event.currentTarget);
      let nextIndex = currentIndex;

      if (event.key === 'ArrowLeft') {
        nextIndex = currentIndex === 0 ? this.tabs.length - 1 : currentIndex - 1;
      }

      if (event.key === 'ArrowRight') {
        nextIndex = currentIndex === this.tabs.length - 1 ? 0 : currentIndex + 1;
      }

      if (event.key === 'Home') {
        nextIndex = 0;
      }

      if (event.key === 'End') {
        nextIndex = this.tabs.length - 1;
      }

      const nextTab = this.tabs[nextIndex];
      this.setActiveItem(nextTab.dataset.kivoHomeDepthTab, true);
    }

    setActiveItem(mode, focusTab) {
      if (!mode) {
        return;
      }

      this.stage.dataset.activeMode = mode;

      this.tabs.forEach((tab) => {
        const isActive = tab.dataset.kivoHomeDepthTab === mode;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        tab.setAttribute('tabindex', isActive ? '0' : '-1');

        if (isActive && focusTab) {
          tab.focus();
        }
      });

      this.items.forEach((item) => {
        const isActive = item.dataset.kivoHomeDepthItem === mode;
        item.classList.toggle('is-active', isActive);
        item.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      });
    }
  }

  customElements.define('kivo-home-depth-modes', KivoHomeDepthModes);
})();
